export default function PopoverScrollContent({maxHeight, children, style={}}) {
    return (
        <div style={{overflowX: 'auto', maxHeight: maxHeight || 500, ...style}}>
            {children}
        </div>
    )
}